/**
 * How the app names a person, and the curator behind an extraction.
 *
 * An extraction has a current OWNER (`data_entries.user_id`, which reopen and
 * reassign move in place) and the ORIGINAL curator (the user on its first
 * "completed" event, `DataEntry.originalExtractor` on the api). When they
 * differ the convention everywhere - Completed Extractions, the QC kanban
 * card, the QC page - is "owner (original)", so a reviewer who took an input
 * over still sees whose work they are reviewing.
 */

/** "First Last", else the email, else "". */
export function personName(person) {
	if (!person) return "";
	const name = [person.firstName, person.lastName].filter(Boolean).join(" ");
	return name || person.email || "";
}

/** "FL" from the name, else the first letter of the email, else "?". */
export function personInitials(person) {
	if (!person) return "?";
	const first = person.firstName?.[0] || "";
	const last = person.lastName?.[0] || "";
	return (
		(first + last).toUpperCase() || person.email?.[0]?.toUpperCase() || "?"
	);
}

/** The local part of the email, else "". */
export function shortEmail(person) {
	const email = person?.email;
	return email ? email.split("@")[0] : "";
}

/** "owner (original)" when the two differ, else just the owner. */
export function curatorPairLabel(owner, original) {
	if (!original || original === owner) return owner;
	return `${owner} (${original})`;
}

/**
 * The curator label for one extraction as the api ships it: `extractor` is
 * the owner, `originalExtractor` the original curator when that is someone
 * else (null otherwise). `nameOf` picks the presentation - full names by
 * default, `shortEmail` where the surface shows emails. An IA input has
 * neither and yields "".
 */
export function curatorLabel(entry, nameOf = personName) {
	return curatorPairLabel(
		nameOf(entry?.extractor),
		nameOf(entry?.originalExtractor),
	);
}
